import { Pill, PillProps, Tooltip } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';

interface CopiablePillProps extends PillProps {
  content: string;
}

export function CopiablePill({ content, ...props }: CopiablePillProps) {
  const clipboard = useClipboard({ timeout: 500 });
  return (
    <Tooltip
      label="Copiat în clipboard"
      opened={clipboard.copied}
      closeDelay={200}
    >
      <Pill
        {...props}
        style={{ cursor: 'pointer' }}
        onClick={() => clipboard.copy(content)}
      >
        {content}
      </Pill>
    </Tooltip>
  );
}
